import MuiChiop, { ChipProps } from '@mui/material/Chip';

function Chip(props: ChipProps) {
  return <MuiChiop {...props} />;
}

export default Chip;
